import React from 'react';
import { useBrokerDetailsStore } from '../../../state/brokerDetailsStore';
import { CompanyInfoPanel } from '../../../components/CompanyInfoPanel/CompanyInfoPanel';
import { AgreementVersionField } from './components/AgreementVersionField';
import { ClientFeeField } from './components/ClientFeeField';
import { PointOfContactField } from './components/PointOfContactField';
import { W9OnFileField } from './components/W9OnFileField';
import { BrokerFlaggedField } from './components/BrokerFlaggedField';
import { BackgroundCheckField } from './components/BackgroundCheckField';
import { DoingAsCompanyField } from './components/DoingAsCompanyField';
import { BackgroundCheckDateField } from './components/BackgroundCheckDateField';
import { NameAndLicensePanel } from '../../../components/NameAndLicensePanel/NameAndLicensePanel';

interface BrokerInfoPanelProps {
    showCompanyPanel: boolean;
    onShowCompanyPanelChange: (value: boolean) => void;
    showBackgroundCheckDate: boolean;
    onShowBackgroundCheckDateChange: (value: boolean) => void;
}

export const BrokerInfoPanel: React.FC<BrokerInfoPanelProps> = ({
    showCompanyPanel,
    onShowCompanyPanelChange,
    showBackgroundCheckDate,
    onShowBackgroundCheckDateChange,
}) => {
    const isAdmin = useBrokerDetailsStore((s) => s.isAdmin);

    return (
        <>
            <h2 className='decorated'>Broker Information</h2>
            <br />
            <NameAndLicensePanel />
            {isAdmin && (
                <>
                    <div className='field-section'>
                        <div className='field-row'>
                            <AgreementVersionField />
                            <ClientFeeField />
                            <PointOfContactField />
                        </div>
                    </div>
                    <W9OnFileField />
                    <BrokerFlaggedField />
                    <BackgroundCheckField
                        showBackgroundCheckDate={showBackgroundCheckDate}
                        onToggle={onShowBackgroundCheckDateChange}
                    />
                </>
            )}
            <DoingAsCompanyField
                showCompanyPanel={showCompanyPanel}
                onToggle={onShowCompanyPanelChange}
            />
            <CompanyInfoPanel showCompanyPanel={showCompanyPanel} />
            <BackgroundCheckDateField showBackgroundCheckDate={showBackgroundCheckDate} />
        </>
    );
};
